export default "assets/images/talks-0f9f964f.svg";